/*
  MEALUP email capture (popup + inline block).
  Markup: snippets/mu-email-capture.liquid, sections/mu-popup.liquid, sections/mu-email-inline.liquid.
  All visible copy comes from section settings via the markup and data attributes.

  Scratch card: a canvas foil over the prize (the discount amount), scratched with pointer events (touch, pen, mouse).
  Past 45% cleared the card opens. A reveal button does the same for keyboard users and reduced motion.
  A/B test (popup, data-ab-mode): "ab" puts each visitor in "scratch" or "survey" at random, 50/50, kept for a year
  (localStorage + cookie). Survey = one question, answer buttons in a shuffled order (data-fixed stays last), then the
  email form with the amount shown ([data-mu-won]). The version and the answer are written into the form's tags (popup-scratch / popup-survey + answer tag)
  and sent to Microsoft Clarity (custom tags popup_variant / popup_answer, events popup_open / popup_answer /
  popup_signup) so views can be compared too.
  Submission: Shopify's customer (newsletter) form, sent with fetch. When the store's hCaptcha is bound to the form,
  Shopify's script runs the invisible check and then calls form.submit(), which is our fetch. Success shows only when
  Shopify confirms (the request ends on ?customer_posted=true). A /challenge (captcha) answer, or no captcha answer
  within 8 s, offers the normal form submit so the visitor can pass Shopify's check; any other answer shows the
  error from the settings.
  Popup rules: phone after N s AND N% scroll, desktop after N s or on exit intent; once per session; a pause of
  N days after a close; never after signup; not on a page view that came with a skipped utm_source; never while a
  drawer or menu is open. The offer tab (left edge, every screen size) hides while a drawer or menu,
  the inline offer or the footer is open or on screen.
*/
(function () {
  if (window.MuCapture) return;

  var SIGNED = 'mu_sub';
  var CLOSED = 'mu_pop_closed';
  var SEEN = 'mu_pop_seen';
  var REVEALED = 'mu_scratch_open';
  var PENDING = 'mu_sub_pending';
  var AB = 'mu_pop_ab';
  var ANSWERED = 'mu_pop_answer';

  // Microsoft Clarity (inline in theme.liquid) and GA4 if a gtag is on the page; silent when neither is there.
  function track(name, key, value) {
    try {
      if (typeof window.clarity === 'function') {
        if (key) window.clarity('set', key, value);
        if (name) window.clarity('event', name);
      }
      if (name && typeof window.gtag === 'function') window.gtag('event', name, key ? { mu_value: value } : {});
    } catch (e) {}
  }

  function getCookie(name) {
    var m = document.cookie.match('(?:^|;)\\s*' + name + '=([^;]*)');
    return m ? decodeURIComponent(m[1]) : null;
  }
  function setCookie(name, value, days) {
    var c = name + '=' + encodeURIComponent(value) + ';path=/;SameSite=Lax';
    if (days) {
      var d = new Date();
      d.setTime(d.getTime() + days * 864e5);
      c += ';expires=' + d.toUTCString();
    }
    if (location.protocol === 'https:') c += ';Secure';
    document.cookie = c;
  }
  function store(kind, key, value) {
    try {
      var s = kind === 'local' ? window.localStorage : window.sessionStorage;
      if (value === undefined) return s.getItem(key);
      if (value === null) s.removeItem(key);
      else s.setItem(key, value);
    } catch (e) {
      return null;
    }
    return null;
  }
  function signedUp() {
    return getCookie(SIGNED) === '1' || store('local', SIGNED) === '1';
  }
  function markSigned() {
    setCookie(SIGNED, '1', 3650);
    store('local', SIGNED, '1');
  }
  function mq(q) {
    return window.matchMedia ? window.matchMedia(q).matches : false;
  }
  function reduceMotion() {
    return mq('(prefers-reduced-motion: reduce)');
  }
  function cssVar(el, name, fallback) {
    var v = getComputedStyle(el).getPropertyValue(name).trim();
    return v || fallback;
  }
  function visible(el) {
    return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length));
  }
  function focusables(container) {
    return Array.prototype.filter.call(
      container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), textarea, select, [tabindex]:not([tabindex="-1"])'),
      function (el) {
        return visible(el) && !el.closest('[hidden]');
      }
    );
  }
  // Any drawer, menu or modal of the theme that is open right now.
  function somethingOpen() {
    var b = document.body;
    if (!b) return false;
    if (/\boverflow-hidden(-mobile|-tablet|-desktop)?\b/.test(b.className)) return true;
    // Shopify's cookie banner first: the visitor answers it before we ask for anything.
    var consent = document.querySelectorAll('#shopify-pc__banner, #shopify-pc__prefs, [data-mu-cc]');
    for (var i = 0; i < consent.length; i++) if (visible(consent[i]) && getComputedStyle(consent[i]).display !== 'none') return true;
    return !!document.querySelector(
      'cart-drawer.active, header-drawer details[open], .menu-drawer-container[open], details-modal details[open], .header-wrapper details[open], .search-modal[open], [data-mu-drawer-open]'
    );
  }

  /* ---------------- Capture: scratch card + form ---------------- */
  function Capture(root) {
    var self = this;
    this.root = root;
    root._muCapture = this;
    this.card = root.querySelector('[data-mu-scratch]');
    this.canvas = root.querySelector('[data-mu-foil]');
    this.prize = root.querySelector('[data-mu-prize]');
    this.revealBtn = root.querySelector('[data-mu-reveal]');
    this.form = root.querySelector('form');
    this.input = root.querySelector('input[type="email"]');
    this.submitBtn = root.querySelector('.mu-cap__submit');
    this.msg = root.querySelector('.mu-cap__msg');
    this.captchaBtn = root.querySelector('[data-mu-captcha]');
    this.live = root.querySelector('[data-mu-live]');
    this.title = root.querySelector('.mu-cap__title');
    this.revealed = false;
    this.scratched = false;
    this.abMode = root.getAttribute('data-ab-mode');
    if (this.abMode) this.initAb();

    if (this.form) {
      this.form.noValidate = true;
      // Shopify's storefront hCaptcha binds to customer forms on first focus: it keeps the form's submit()
      // as "send after the captcha" and calls it once the token is in the form. Giving the form our own submit()
      // first makes that call our fetch, so the token travels with it and the page never reloads.
      try {
        this.form.submit = function () {
          self.send();
        };
      } catch (e) {}
      this.form.addEventListener('submit', function (e) {
        self.onSubmit(e);
      });
    }
    if (this.revealBtn)
      this.revealBtn.addEventListener('click', function () {
        self.reveal({ byButton: true });
      });
    if (this.captchaBtn)
      this.captchaBtn.addEventListener('click', function () {
        self.nativeSubmit();
      });
    if (this.input)
      this.input.addEventListener('input', function () {
        self.clearMsg();
      });
    this.initScratch();

    if (root.querySelector('[data-mu-posted]')) {
      markSigned();
      this.setState('done');
    } else if (this.ab === 'survey') {
      var answered = store('session', ANSWERED);
      var prev = answered && root.querySelector('[data-mu-answers] [data-tag="' + answered + '"]');
      if (prev) this.answer(prev, true);
      else this.setState('ask');
    } else if (store('session', REVEALED) === '1') {
      this.reveal({ silent: true });
    }
  }

  // Picks this visitor's version and prepares the question.
  Capture.prototype.initAb = function () {
    var self = this;
    var root = this.root;
    var v = this.abMode;
    if (window.Shopify && window.Shopify.designMode) {
      v = root.getAttribute('data-ab-editor') || 'survey';
    } else if (v === 'ab') {
      v = store('local', AB) || getCookie(AB);
      if (v !== 'scratch' && v !== 'survey') v = Math.random() < 0.5 ? 'scratch' : 'survey';
      store('local', AB, v);
      setCookie(AB, v, 365);
    }
    var box = root.querySelector('[data-mu-answers]');
    if (v !== 'survey' || !box || !box.querySelector('[data-tag]')) v = 'scratch';
    this.ab = v;
    root.setAttribute('data-ab', v);
    if (v === 'survey' && this.submitBtn && this.submitBtn.getAttribute('data-label-survey')) {
      this.submitBtn.setAttribute('data-label', this.submitBtn.getAttribute('data-label-survey'));
      this.submitBtn.textContent = this.submitBtn.getAttribute('data-label-survey');
    }
    var tagInput = root.querySelector('input[name="contact[tags]"]');
    this.tagBase = tagInput ? tagInput.value : '';
    this.setTags();
    track(null, 'popup_variant', v);
    if (v !== 'survey') return;
    var btns = Array.prototype.slice.call(box.querySelectorAll('[data-tag]'));
    // a new order for every visitor, so no answer wins just by being first; the theme editor keeps the block order
    if (!(window.Shopify && window.Shopify.designMode)) {
      var free = btns.filter(function (b) {
        return !b.hasAttribute('data-fixed');
      });
      for (var i = free.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var t = free[i];
        free[i] = free[j];
        free[j] = t;
      }
      free.concat(btns.filter(function (b) {
        return b.hasAttribute('data-fixed');
      })).forEach(function (b) {
        box.appendChild(b);
      });
    }
    btns.forEach(function (b) {
      b.setAttribute('aria-pressed', 'false');
      b.addEventListener('click', function () {
        self.answer(b);
      });
    });
  };

  Capture.prototype.setTags = function () {
    var t = [this.tagBase, 'popup-' + this.ab, this.answerTag].filter(Boolean).join(',');
    Array.prototype.forEach.call(this.root.querySelectorAll('input[name="contact[tags]"], input[name="customer[tags]"]'), function (el) {
      el.value = t;
    });
  };

  Capture.prototype.answer = function (btn, silent) {
    var self = this;
    this.answerTag = btn.getAttribute('data-tag');
    store('session', ANSWERED, this.answerTag);
    Array.prototype.forEach.call(this.root.querySelectorAll('[data-mu-answers] [data-tag]'), function (b) {
      b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
    });
    this.setTags();
    this.setState('form');
    if (silent) return;
    var won = this.root.querySelector('[data-mu-won]');
    if (this.live && won) this.live.textContent = won.textContent.replace(/\s+/g, ' ').trim();
    track('popup_answer', 'popup_answer', this.answerTag);
    if (this.input) {
      setTimeout(function () {
        self.input.focus({ preventScroll: true });
      }, 60);
    }
  };

  Capture.prototype.setState = function (state) {
    this.root.setAttribute('data-state', state);
    Array.prototype.forEach.call(this.root.querySelectorAll('[data-show]'), function (el) {
      el.hidden = el.getAttribute('data-show').split(' ').indexOf(state) === -1;
    });
  };

  Capture.prototype.initScratch = function () {
    var self = this;
    var c = this.canvas;
    if (!c || !c.getContext) return;
    this.ctx = c.getContext('2d', { willReadFrequently: true });
    this.paint();
    if (document.fonts && document.fonts.load) {
      Promise.all([document.fonts.load('400 30px "MEALUP Display"'), document.fonts.load('700 14px "SN Pro"')])
        .then(function () {
          if (!self.scratched && !self.revealed) self.paint();
        })
        .catch(function () {});
    }
    if ('ResizeObserver' in window) {
      new ResizeObserver(function () {
        if (!self.scratched && !self.revealed) self.paint();
      }).observe(this.card);
    }
    c.addEventListener('pointerdown', function (e) {
      self.down(e);
    });
    c.addEventListener('pointermove', function (e) {
      self.move(e);
    });
    c.addEventListener('pointerup', function () {
      self.up();
    });
    c.addEventListener('pointercancel', function () {
      self.up();
    });
  };

  // The foil: house orange, a chevron line from the pack top and bottom, the label in espresso as on the bag.
  Capture.prototype.paint = function () {
    var c = this.canvas;
    if (!c || !this.ctx) return;
    var r = c.getBoundingClientRect();
    if (!r.width || !r.height) return;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    c.width = Math.round(r.width * dpr);
    c.height = Math.round(r.height * dpr);
    var x = this.ctx;
    var w = r.width;
    var h = r.height;
    x.setTransform(dpr, 0, 0, dpr, 0, 0);
    x.globalCompositeOperation = 'source-over';
    x.fillStyle = cssVar(this.root, '--orange', '#EC7023');
    x.fillRect(0, 0, w, h);
    x.fillStyle = cssVar(this.root, '--orange-l', '#F79038');
    [10, h - 18].forEach(function (y) {
      for (var i = 8; i < w - 8; i += 10) {
        x.beginPath();
        x.moveTo(i, y);
        x.lineTo(i + 6, y);
        x.lineTo(i + 3, y + 8);
        x.closePath();
        x.fill();
      }
    });
    var ink = cssVar(this.root, '--espresso', '#2E130C');
    var size = Math.round(Math.max(24, Math.min(36, w / 10, h / 3.6)));
    var label = (this.root.getAttribute('data-foil-label') || '').toUpperCase();
    var hint = this.root.getAttribute('data-foil-hint') || '';
    x.fillStyle = ink;
    x.textAlign = 'center';
    x.textBaseline = 'middle';
    x.font = '400 ' + size + 'px "MEALUP Display", "Arial Black", sans-serif';
    x.fillText(label, w / 2, h / 2 - (hint ? 9 : 0));
    if (hint) {
      x.font = '700 14px "SN Pro", system-ui, sans-serif';
      x.fillText(hint, w / 2, h / 2 + size / 2 + 6);
    }
    this.strokes = 0;
  };

  Capture.prototype.point = function (e) {
    var r = this.canvas.getBoundingClientRect();
    return { x: e.clientX - r.left, y: e.clientY - r.top };
  };
  Capture.prototype.down = function (e) {
    if (this.revealed || !this.ctx) return;
    if (e.pointerType === 'mouse') e.preventDefault();
    this.drawing = true;
    this.last = this.point(e);
    try {
      this.canvas.setPointerCapture(e.pointerId);
    } catch (err) {}
    this.scratch(this.last, this.last);
  };
  Capture.prototype.move = function (e) {
    if (!this.drawing || this.revealed) return;
    var p = this.point(e);
    this.scratch(this.last, p);
    this.last = p;
    this.strokes += 1;
    if (this.strokes % 6 === 0) this.check();
  };
  Capture.prototype.up = function () {
    if (!this.drawing) return;
    this.drawing = false;
    this.check();
  };
  Capture.prototype.scratch = function (a, b) {
    var x = this.ctx;
    var h = this.canvas.getBoundingClientRect().height;
    x.globalCompositeOperation = 'destination-out';
    x.lineCap = 'round';
    x.lineJoin = 'round';
    x.lineWidth = Math.max(34, h / 3.2);
    x.beginPath();
    x.moveTo(a.x, a.y);
    x.lineTo(b.x + 0.01, b.y);
    x.stroke();
    this.scratched = true;
  };
  Capture.prototype.check = function () {
    var c = this.canvas;
    if (!c || !c.width || !c.height || this.revealed) return;
    var data;
    try {
      data = this.ctx.getImageData(0, 0, c.width, c.height).data;
    } catch (e) {
      return;
    }
    var clear = 0;
    var total = 0;
    for (var i = 3; i < data.length; i += 4 * 9) {
      total += 1;
      if (data[i] < 128) clear += 1;
    }
    if (total && clear / total > 0.45) this.reveal({});
  };

  Capture.prototype.reveal = function (opts) {
    opts = opts || {};
    // the question version has no card: a scratch somewhere else on the page never skips the question
    if (this.revealed || this.ab === 'survey') return;
    var self = this;
    this.revealed = true;
    store('session', REVEALED, '1');
    var hadFocus = this.root.contains(document.activeElement);
    var c = this.canvas;
    if (c) {
      c.style.pointerEvents = 'none';
      if (opts.silent || reduceMotion()) {
        c.remove();
      } else {
        c.classList.add('is-gone');
        setTimeout(function () {
          c.remove();
        }, 380);
      }
    }
    if (this.prize) this.prize.removeAttribute('aria-hidden');
    this.setState('form');
    if (opts.silent) return;
    if (this.live && this.prize) this.live.textContent = this.prize.textContent.replace(/\s+/g, ' ').trim();
    var inPopup = !!this.root.closest('[data-mu-popup]');
    if (this.input && (opts.byButton || (inPopup && !mq('(hover: none)')))) {
      setTimeout(function () {
        self.input.focus({ preventScroll: !opts.byButton });
      }, opts.byButton ? 30 : 400);
    } else if (hadFocus && this.title) {
      this.title.focus({ preventScroll: true });
    }
    document.dispatchEvent(new CustomEvent('mu:revealed', { detail: { from: this } }));
  };

  Capture.prototype.busy = function (on) {
    if (!this.submitBtn) return;
    this.submitBtn.disabled = on;
    this.submitBtn.textContent = on ? this.root.getAttribute('data-sending') || '' : this.submitBtn.getAttribute('data-label') || '';
    this.form.setAttribute('aria-busy', on ? 'true' : 'false');
  };
  Capture.prototype.showMsg = function (text, fieldError) {
    if (!this.msg) return;
    this.msg.textContent = text || '';
    this.msg.hidden = !text;
    if (fieldError && this.input) this.input.setAttribute('aria-invalid', 'true');
  };
  Capture.prototype.clearMsg = function () {
    if (this.msg) {
      this.msg.hidden = true;
      this.msg.textContent = '';
    }
    if (this.input) this.input.removeAttribute('aria-invalid');
    if (this.captchaBtn) this.captchaBtn.hidden = true;
  };

  Capture.prototype.onSubmit = function (e) {
    e.preventDefault();
    var self = this;
    var email = (this.input.value || '').trim();
    if (this.sending) {
      e.stopImmediatePropagation();
      return;
    }
    this.clearMsg();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
      e.stopImmediatePropagation();
      this.showMsg(this.root.getAttribute('data-err-email'), true);
      this.input.focus();
      return;
    }
    this.input.value = email;
    if (this.form.getAttribute('data-hcaptcha-bound')) {
      // Shopify's captcha listener runs next and calls form.submit() (= send) with its token.
      this.busy(true);
      clearTimeout(this.captchaTimer);
      this.captchaTimer = setTimeout(function () {
        if (self.sending) return;
        self.busy(false);
        self.showMsg(self.root.getAttribute('data-err-captcha'));
        if (self.captchaBtn) self.captchaBtn.hidden = false;
      }, 8000);
      return;
    }
    this.send();
  };

  Capture.prototype.send = function () {
    var self = this;
    clearTimeout(this.captchaTimer);
    if (this.sending) return;
    this.clearMsg();
    this.sending = true;
    this.busy(true);
    // URL-encoded, exactly what a native submit of this form sends.
    var body = new URLSearchParams();
    new FormData(this.form).forEach(function (v, k) {
      body.append(k, v);
    });
    fetch((this.form.getAttribute('action') || '/contact').split('#')[0], {
      method: 'POST',
      body: body,
      credentials: 'same-origin',
      headers: { Accept: 'text/html', 'Content-Type': 'application/x-www-form-urlencoded' },
    })
      .then(function (res) {
        var url = res.url || '';
        if (/\/challenge\b/.test(url)) return 'captcha';
        if (res.ok && /[?&]customer_posted=true/.test(url)) return 'ok';
        // the store's bot check ("Verifying your connection", 429/403): the normal form submit lets the visitor pass it
        if (res.status === 429 || res.status === 403) return 'captcha';
        return res.text().then(function (html) {
          var kind = 'error';
          try {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            if (doc.querySelector('.h-captcha, [data-hcaptcha-widget-id], form[action*="challenge"], #g-recaptcha')) kind = 'captcha';
            var err = doc.querySelector('[data-mu-form-error]');
            if (err && err.getAttribute('data-mu-form-error') === 'email') kind = 'email';
          } catch (err2) {}
          return kind;
        });
      })
      .catch(function () {
        return 'error';
      })
      .then(function (kind) {
        self.sending = false;
        self.busy(false);
        if (kind === 'ok') return self.success();
        if (kind === 'captcha') {
          self.showMsg(self.root.getAttribute('data-err-captcha'));
          if (self.captchaBtn) self.captchaBtn.hidden = false;
          return;
        }
        if (kind === 'email') {
          self.showMsg(self.root.getAttribute('data-err-email'), true);
          self.input.focus();
          return;
        }
        self.showMsg(self.root.getAttribute('data-err-generic'));
      });
  };

  // Shopify asked for a captcha: send the form the normal way so the visitor lands on Shopify's check.
  Capture.prototype.nativeSubmit = function () {
    store('session', PENDING, this.root.getAttribute('data-variant') || 'inline');
    HTMLFormElement.prototype.submit.call(this.form);
  };

  Capture.prototype.success = function (quiet) {
    markSigned();
    // email gift (assets/mu-gift.js): the signup unlocks the gift product
    if (window.MU_GIFT && this.root.getAttribute('data-variant') === 'popup') {
      setCookie('mu_gift', '1', 3650);
      store('local', 'mu_gift', '1');
      document.documentElement.classList.add('mu-gift-on');
      document.dispatchEvent(new CustomEvent('mu:gift'));
    }
    store('session', PENDING, null);
    this.setState('done');
    if (quiet) return;
    var t = this.root.querySelector('.mu-cap__title');
    var p = this.root.querySelector('.mu-cap__text');
    if (this.live) this.live.textContent = ((t ? t.textContent : '') + '. ' + (p ? p.textContent : '')).replace(/\s+/g, ' ').trim();
    if (this.title) this.title.focus({ preventScroll: true });
    if (this.ab) track('popup_signup', 'popup_signed', this.ab);
    document.dispatchEvent(new CustomEvent('mu:signed', { detail: { from: this } }));
  };

  /* ---------------- Popup ---------------- */
  function Popup(root) {
    var self = this;
    var d = root.dataset;
    this.root = root;
    this.dialog = root.querySelector('.mu-pop__dialog');
    var capEl = root.querySelector('[data-mu-capture]');
    this.capture = capEl ? capEl._muCapture : null;
    this.tab = root.parentElement ? root.parentElement.querySelector('[data-mu-pop-tab]') : null;
    this.design = d.design === 'true';
    this.cfg = {
      mDelay: parseFloat(d.mobileDelay) || 45,
      mScroll: (parseFloat(d.mobileScroll) || 60) / 100,
      dDelay: parseFloat(d.desktopDelay) || 40,
      exit: d.exit === 'true',
      closeDays: parseFloat(d.closeDays) || 14,
      skip: (d.skipUtm || '')
        .toLowerCase()
        .split(',')
        .map(function (v) {
          return v.trim();
        })
        .filter(Boolean),
      tab: d.tab === 'true',
      auto: d.auto !== 'false',
    };
    this.isOpen = false;
    this.inerted = [];

    Array.prototype.forEach.call(root.querySelectorAll('[data-mu-pop-close]'), function (el) {
      el.addEventListener('click', function () {
        self.close();
      });
    });
    this.onKeyBound = function (e) {
      self.onKey(e);
    };
    if (this.tab)
      this.tab.addEventListener('click', function () {
        self.open('tab');
      });
    document.addEventListener('mu:signed', function () {
      self.updateTab();
    });
    // the "?" gift tile on the product page (assets/mu-gift.js) opens the popup
    document.addEventListener('mu:popup-open', function () {
      self.open('gift-tile');
    });

    if (this.design) {
      document.addEventListener('shopify:section:select', function (e) {
        if (e.target && e.target.contains(root)) self.open('editor');
      });
      document.addEventListener('shopify:section:deselect', function (e) {
        if (e.target && e.target.contains(root)) self.close(true);
      });
      return;
    }

    if (this.capture && this.capture.root.getAttribute('data-state') === 'done' && store('session', PENDING) === 'popup') {
      store('session', PENDING, null);
      this.open('posted');
      return;
    }
    if (signedUp()) return;
    this.setupTab();
    if (!this.cfg.auto || this.autoBlocked()) return;
    this.arm();
  }

  Popup.prototype.autoBlocked = function () {
    if (getCookie(CLOSED) || getCookie(SEEN)) return true;
    var src = '';
    try {
      src = (new URLSearchParams(location.search).get('utm_source') || '').toLowerCase();
    } catch (e) {}
    return !!src && this.cfg.skip.indexOf(src) !== -1;
  };

  Popup.prototype.arm = function () {
    var self = this;
    var started = Date.now();
    if (mq('(max-width: 749px)') || mq('(hover: none)')) {
      var timeOk = false;
      var scrollOk = false;
      var tryOpen = function () {
        if (timeOk && scrollOk) self.autoOpen();
      };
      var onScroll = function () {
        var max = document.documentElement.scrollHeight - window.innerHeight;
        if (max <= 0 || window.scrollY / max >= self.cfg.mScroll) {
          scrollOk = true;
          window.removeEventListener('scroll', onScroll);
          tryOpen();
        }
      };
      setTimeout(function () {
        timeOk = true;
        onScroll();
        tryOpen();
      }, this.cfg.mDelay * 1000);
      window.addEventListener('scroll', onScroll, { passive: true });
    } else {
      setTimeout(function () {
        self.autoOpen();
      }, this.cfg.dDelay * 1000);
      if (this.cfg.exit) {
        var onOut = function (e) {
          if (!e.relatedTarget && e.clientY <= 0 && Date.now() - started > 3000) {
            document.removeEventListener('mouseout', onOut);
            self.autoOpen();
          }
        };
        document.addEventListener('mouseout', onOut);
      }
    }
  };

  Popup.prototype.autoOpen = function () {
    var self = this;
    if (this.isOpen || this.autoDone || signedUp() || this.autoBlocked()) return;
    if (somethingOpen()) {
      clearTimeout(this.retry);
      this.retry = setTimeout(function () {
        self.autoOpen();
      }, 1500);
      return;
    }
    this.autoDone = true;
    this.open('auto');
  };

  Popup.prototype.open = function (reason) {
    if (this.isOpen) return;
    var self = this;
    this.isOpen = true;
    this.reason = reason;
    if (!this.design) track('popup_open', 'popup_open_reason', reason);
    if (!this.design) setCookie(SEEN, '1');
    this.returnTo = document.activeElement && document.activeElement !== document.body ? document.activeElement : null;
    this.root.hidden = false;
    document.documentElement.classList.add('mu-pop-lock');
    this.setInert(true);
    this.updateTab();
    document.addEventListener('keydown', this.onKeyBound, true);
    requestAnimationFrame(function () {
      self.root.classList.add('is-open');
      if (self.capture && !self.capture.scratched && !self.capture.revealed) self.capture.paint();
    });
    setTimeout(function () {
      var cap = self.capture;
      var state = cap ? cap.root.getAttribute('data-state') : '';
      var target = null;
      if (cap && state === 'offer') target = cap.revealBtn;
      else if (cap && state === 'ask') target = cap.root.querySelector('[data-mu-answers] [data-tag]');
      else if (cap && state === 'form') target = cap.input;
      else if (cap) target = cap.title;
      (target || self.root.querySelector('.mu-pop__close')).focus({ preventScroll: true });
    }, 60);
  };

  Popup.prototype.close = function (fromEditor) {
    if (!this.isOpen) return;
    var self = this;
    this.isOpen = false;
    if (!this.design && !fromEditor && !signedUp()) setCookie(CLOSED, '1', this.cfg.closeDays);
    this.root.classList.remove('is-open');
    document.removeEventListener('keydown', this.onKeyBound, true);
    document.documentElement.classList.remove('mu-pop-lock');
    this.setInert(false);
    setTimeout(
      function () {
        if (!self.isOpen) self.root.hidden = true;
      },
      reduceMotion() ? 0 : 240
    );
    // Show the tab again first, so focus can return to it when the popup was opened from it.
    this.updateTab();
    if (this.returnTo && document.contains(this.returnTo) && this.returnTo.focus) this.returnTo.focus({ preventScroll: true });
  };

  Popup.prototype.onKey = function (e) {
    if (!this.isOpen) return;
    if (e.key === 'Escape' || e.key === 'Esc') {
      e.preventDefault();
      e.stopPropagation();
      this.close();
      return;
    }
    if (e.key !== 'Tab') return;
    var list = focusables(this.dialog);
    if (!list.length) return;
    var first = list[0];
    var last = list[list.length - 1];
    var active = document.activeElement;
    if (!this.dialog.contains(active)) {
      e.preventDefault();
      first.focus();
    } else if (e.shiftKey && (active === first || active === this.dialog)) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && active === last) {
      e.preventDefault();
      first.focus();
    }
  };

  // While open, everything outside the popup is inert (no focus, no screen reader).
  Popup.prototype.setInert = function (on) {
    if (!on) {
      this.inerted.forEach(function (el) {
        el.inert = false;
        el.removeAttribute('inert');
      });
      this.inerted = [];
      return;
    }
    var keep = this.root;
    var list = this.inerted;
    for (var el = keep; el && el.parentElement; el = el.parentElement) {
      Array.prototype.forEach.call(el.parentElement.children, function (sib) {
        if (sib === el || /^(SCRIPT|STYLE|LINK|TEMPLATE)$/.test(sib.tagName) || sib.inert) return;
        // Shopify's hCaptcha challenge lives in its own container under <body>: it must stay usable.
        if (sib.querySelector && sib.querySelector('iframe[src*="hcaptcha"]')) return;
        sib.inert = true;
        sib.setAttribute('inert', '');
        list.push(sib);
      });
      if (el.parentElement === document.body) break;
    }
  };

  Popup.prototype.setupTab = function () {
    var self = this;
    if (!this.tab || !this.cfg.tab) return;
    setTimeout(function () {
      self.tabReady = true;
      self.updateTab();
    }, 4000);
    var queued = false;
    var queue = function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        self.updateTab();
      });
    };
    if ('MutationObserver' in window) {
      new MutationObserver(queue).observe(document.body, { attributes: true, subtree: true, attributeFilter: ['class', 'open'] });
    }
    // The tab steps aside while the inline offer or the footer is on screen, so it never covers them.
    if ('IntersectionObserver' in window) {
      var seen = new Set();
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) seen.add(en.target);
          else seen.delete(en.target);
        });
        self.tabCovered = seen.size > 0;
        queue();
      });
      Array.prototype.forEach.call(document.querySelectorAll('[data-mu-inline], .mu-footer'), function (el) {
        io.observe(el);
      });
    }
    window.addEventListener('resize', queue);
    // The cookie banner closes without a class change: re-check on scroll as well (once per frame).
    window.addEventListener('scroll', queue, { passive: true });
    document.addEventListener('visitorConsentCollected', function () {
      setTimeout(queue, 500);
    });
  };

  Popup.prototype.updateTab = function () {
    if (!this.tab) return;
    var show =
      this.cfg.tab && this.tabReady && !this.tabCovered && !this.isOpen && !signedUp() && !somethingOpen();
    if (this.tab.hidden === !show) return;
    this.tab.hidden = !show;
  };

  /* ---------------- Inline blocks ---------------- */
  function initInline() {
    var blocks = document.querySelectorAll('[data-mu-inline]');
    Array.prototype.forEach.call(blocks, function (el) {
      var cap = el.querySelector('[data-mu-capture]');
      var done = cap && cap.getAttribute('data-state') === 'done';
      var duplicate = blocks.length > 1 && el.getAttribute('data-footer') === 'true';
      var section = el.closest('.shopify-section') || el;
      if (duplicate || (signedUp() && !done)) section.hidden = true;
    });
    if (store('session', PENDING) === 'inline') {
      var shown = Array.prototype.filter.call(blocks, function (el) {
        var cap = el.querySelector('[data-mu-capture]');
        return cap && cap.getAttribute('data-state') === 'done' && !(el.closest('.shopify-section') || el).hidden;
      })[0];
      store('session', PENDING, null);
      if (shown) shown.scrollIntoView({ block: 'center' });
    }
  }

  function init(scope) {
    scope = scope || document;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-mu-capture]'), function (el) {
      if (!el._muCapture) new Capture(el);
    });
    Array.prototype.forEach.call(scope.querySelectorAll('[data-mu-popup]'), function (el) {
      if (!el._muPopup) el._muPopup = new Popup(el);
    });
    initInline();
  }

  // One reveal or signup counts for every capture on the page.
  document.addEventListener('mu:revealed', function (e) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-mu-capture]'), function (el) {
      if (el._muCapture && el._muCapture !== e.detail.from) el._muCapture.reveal({ silent: true });
    });
  });
  document.addEventListener('mu:signed', function (e) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-mu-capture]'), function (el) {
      if (el._muCapture && el._muCapture !== e.detail.from) el._muCapture.success(true);
    });
  });
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });

  window.MuCapture = { init: init, signedUp: signedUp };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
})();
